import React from 'react';
import './aboutus.css';

function AboutPage() {
  return (
    <main className='page-shell about-page'>
      <section className='page-hero'>
        <div className='page-copy'>
          <span className='eyebrow'>About Viewjot</span>
          <h1>Building smarter businesses through digital excellence.</h1>
          <p>
            Viewjot helps organizations modernize operations, expand their reach, and unlock new growth
            opportunities through technology, industrial support, and digital commerce solutions.
          </p>
        </div>
      </section>

      <section className='story-grid'>
        <div className='story-panel'>
          <h2>Who We Are</h2>
          <p>
            We are a strategy-led technology and business support company focused on practical innovation.
            From software and support engineering to e-commerce and automotive services, we help clients
            move from idea to execution with clarity and measurable value.
          </p>
        </div>

        <div className='story-panel'>
          <h2>What We Do</h2>
          <p>
            We combine product thinking, operational experience, and engineering discipline to deliver
            business solutions that are reliable, scalable, and designed for real-world impact.
          </p>
        </div>
      </section>

      <section className='mission-section'>
        <div className='section-heading'>
          <span className='eyebrow'>Our approach</span>
          <h2>Vision & Values</h2>
        </div>

        <div className='value-grid'>
          <article className='value-card'>
            <h3>Vision</h3>
            <p>
              To be a trusted partner for businesses seeking transformative growth through reliable,
              sustainable, and technology-driven solutions.
            </p>
          </article>

          <article className='value-card'>
            <h3>Innovation</h3>
            <p>
              We continuously seek smarter ways to solve problems, create opportunities, and keep our
              solutions future-ready.
            </p>
          </article>

          <article className='value-card'>
            <h3>Integrity</h3>
            <p>
              We build lasting relationships through transparency, accountability, and quality in every
              interaction and project.
            </p>
          </article>

          <article className='value-card'>
            <h3>Impact</h3>
            <p>
              Every solution we deliver is designed to create measurable business value for the people and
              organizations we serve.
            </p>
          </article>
        </div>
      </section>
    </main>
  );
}

export default AboutPage;
